import * as React from "react";

import MainLayout from "../../src/components/Layout/MainLayout";
import ProductFeedSearch from "../../src/components/Content/Product/ProductFeedSearch";
import SeoHead from "../../src/components/Seo/SeoHead";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  content: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.globalMarginDesktop,
      marginRight: theme.globalMarginDesktop,
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.globalMarginMobile,
      marginRight: theme.globalMarginMobile,
    },
  },
}));

const Search = () => {
  const classes = useStyles();
  const { t, lang: locale } = useTranslation("common");
  const router = useRouter();
  const { s } = router.query;
  const searchString: string = s ? (s as string) : "";
  const canonicalUrl = `https://thecycleverse.com/${locale}/products/search`;

  const onApplyCategoryFilter = (params) => {
    const brands = (params.brands ? params.brands : []).join(",");
    const sorting = params.sorting ? params.sorting : "";
    const condition = params.condition ? params.condition : "";
    const price = (params.priceRange ? params.priceRange : []).join(",");
    const categories = params?.categories ? params.categories : [];
    const search = params.searchString ? params.searchString : searchString;

    const query = {
      b: brands,
      o: sorting,
      d: condition,
      p: price,
      s: search,
      c: encodeURIComponent(categories.join(",")),
    };
    const url = {
      pathname: "/products/search",
      query,
    };
    router.push(url, url, { shallow: true, locale });
  };

  return (
    <MainLayout searchBar="productSticky">
      <SeoHead
        title={t("productSearchTitle", { searchString })}
        description={t("productSearchTitle", { searchString })}
        canonical={canonicalUrl}
      />
      <div className={classes.content} data-test="page-products-search">
        <ProductFeedSearch onApplyFilter={onApplyCategoryFilter} searchString={searchString} />
      </div>
    </MainLayout>
  );
};

export default Search;
